import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMenuStore = defineStore('menu', () => {
  const lastSelectedMenuLink = ref('')
  const setMenuLink = (link: string | undefined) => {
    if (link) {
      lastSelectedMenuLink.value = link
    }
  }

  /**
   * route.meta 의 isDynamicTitle 이 true 일 경우 사용할 title
   */
  const dynamicTitle = ref('')

  return {
    lastSelectedMenuLink,
    setMenuLink,
    dynamicTitle,
  }
})
